export const IDEA_COLUMN_WIDTH_PX = {
  S: 100,
  M: 150,
  L: 275,
  XL: 350,
} as const;

export type IdeaColumnWidthSize = keyof typeof IDEA_COLUMN_WIDTH_PX;

export const IDEA_COLUMN_MAX_WIDTH_PX = IDEA_COLUMN_WIDTH_PX.XL;

export const IDEA_COLUMN_WIDTH_OPTIONS: { value: IdeaColumnWidthSize; label: string }[] = [
  { value: 'S', label: 'S' },
  { value: 'M', label: 'M' },
  { value: 'L', label: 'L' },
  { value: 'XL', label: 'XL' },
];

export function getIdeaColumnWidthNumber(size: IdeaColumnWidthSize | string): number {
  if (size in IDEA_COLUMN_WIDTH_PX) {
    return IDEA_COLUMN_WIDTH_PX[size as IdeaColumnWidthSize];
  }
  return IDEA_COLUMN_WIDTH_PX.M;
}

export function getIdeaColumnSizeFromWidth(width: number | string | undefined): IdeaColumnWidthSize {
  if (width == null) return 'M';
  const w = typeof width === 'number' ? width : parseFloat(width);
  if (Number.isNaN(w)) return 'M';
  if (w <= IDEA_COLUMN_WIDTH_PX.S) return 'S';
  if (w <= IDEA_COLUMN_WIDTH_PX.M) return 'M';
  if (w <= IDEA_COLUMN_WIDTH_PX.L) return 'L';
  if (w <= IDEA_COLUMN_WIDTH_PX.XL) return 'XL';
  return 'XL';
}

// Clamp a raw px width value to <= XL. Strings like "initial" / undefined pass through unchanged.
export function clampIdeaColumnWidth(
  width: number | string | undefined
): number | string | undefined {
  if (typeof width === 'number') {
    return Math.min(width, IDEA_COLUMN_MAX_WIDTH_PX);
  }
  if (typeof width === 'string') {
    const match = width.match(/^(\d+(?:\.\d+)?)(px)?$/);
    if (match) {
      const px = Math.min(parseFloat(match[1]), IDEA_COLUMN_MAX_WIDTH_PX);
      return `${px}px`;
    }
  }
  return width;
}

export function exceedsIdeaColumnMaxWidth(width: number | string | undefined): boolean {
  if (typeof width === 'number') return width > IDEA_COLUMN_MAX_WIDTH_PX;
  if (typeof width === 'string') {
    const match = width.match(/^(\d+(?:\.\d+)?)(px)?$/);
    if (match) return parseFloat(match[1]) > IDEA_COLUMN_MAX_WIDTH_PX;
  }
  return false;
}
